/**
 * Jediná mapa kategorie lišty -> signály Google Consent Mode v2. Používá ji ConsentManager (bundle)
 * i inline snippet (consent-default.inline.js). ES5, protože snippet se builduje s target es5.
 */
export function consentSignals(c) {
  var a = c && c.analytics ? 'granted' : 'denied';
  var m = c && c.marketing ? 'granted' : 'denied';
  return {
    analytics_storage: a,
    functionality_storage: a,
    ad_storage: m,
    ad_user_data: m,
    ad_personalization: m,
    personalization_storage: m
  };
}
